export default [
  {
    path: '/expenses',
    name: 'expenses-index',
    component: () => import('@/views/expenses/Index.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Gestion des Dépenses',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/create',
    name: 'expenses-create',
    component: () => import('@/views/expenses/Create.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Nouvelle Dépense',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Nouvelle Dépense',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/edit/:id',
    name: 'expenses-edit',
    component: () => import('@/views/expenses/Edit.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Modifier la Dépense',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Modifier',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/show/:id',
    name: 'expenses-show',
    component: () => import('@/views/expenses/Show.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Détails de la Dépense',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/vendors',
    name: 'vendors-index',
    component: () => import('@/views/expenses/vendors/Index.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Gestion des Fournisseurs',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Fournisseurs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/categories',
    name: 'categories-index',
    component: () => import('@/views/expenses/categories/Index.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Gestion des Catégories',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Catégories',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/analytics/revenue',
    name: 'revenue-analytics',
    component: () => import('@/views/expenses/analytics/Revenue.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Tableau de Bord - Revenus',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Analytics Revenus',
          active: true,
        },
      ],
    },
  },
  {
    path: '/expenses/analytics/expenses',
    name: 'expenses-analytics',
    component: () => import('@/views/expenses/analytics/Expenses.vue'),
    meta: {
      requireLogin: true,
      allowedRoles: ['admin', 'accountant'],
      pageTitle: 'Tableau de Bord - Dépenses',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Dépenses',
          to: '/expenses',
        },
        {
          text: 'Analytics Dépenses',
          active: true,
        },
      ],
    },
  },
]
